import { createFileRoute, redirect } from '@tanstack/react-router'
import { PeriodCloseScreen } from '@/features/accounting-close/period-close-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/close')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_period_lock.create')) throw redirect({ to: '/' })
  },
  component: PeriodCloseScreen,
})
